import { render, staticRenderFns } from "./third.vue?vue&type=template&id=dc80e106&"
import script from "./third.vue?vue&type=script&lang=js&"
export * from "./third.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc80e106')) {
      api.createRecord('dc80e106', component.options)
    } else {
      api.reload('dc80e106', component.options)
    }
    module.hot.accept("./third.vue?vue&type=template&id=dc80e106&", function () {
      api.rerender('dc80e106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/first/third.vue"
export default component.exports